var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7836 89.8269C96.5368 89.8269 93.5065 90.4762 90.6927 91.9913C85.7143 94.3723 80.9524 94.3723 75.7576 91.9913C69.697 89.1775 63.4199 89.1775 57.3593 91.9913C52.381 94.3723 47.6191 94.3723 42.6407 91.9913C41.342 91.342 40.0433 90.9091 38.5281 90.4762C33.5498 89.3939 28.7879 89.6104 24.2424 91.9913C20.7792 93.723 17.0996 94.3723 13.2035 93.5065C12.5541 93.29 11.6883 93.0736 11.039 92.8572C7.57577 91.1256 4.11257 90.0433 0.216463 90.0433C0.216463 88.0952 0.216463 86.3636 0.216463 84.4156C2.38097 84.4156 4.32901 84.632 6.27706 85.2814C7.57576 85.7143 9.09092 86.3636 10.3896 87.013C14.5022 88.7446 18.8312 88.961 22.9437 87.013C27.0563 85.0649 31.3853 84.1991 35.9308 84.632C38.3117 84.8485 40.4762 85.4978 42.6407 86.5801C47.6191 88.961 52.381 88.961 57.3593 86.5801C58.658 85.9307 60.1732 85.2814 61.6883 85.0649C66.6667 83.9827 71.4286 84.1991 75.974 86.5801C80.9524 88.961 85.7143 88.961 90.6927 86.5801C91.5585 86.1472 92.6407 85.7143 93.723 85.4978C95.8875 85.0649 97.8355 84.8485 100 84.4156C99.7836 86.1472 99.7836 88.0952 99.7836 89.8269Z",
    fill: "url(#paint0_linear_1939_91)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 99.7836C0 98.4849 0 97.1861 0 95.671C2.1645 95.671 3.89611 95.8875 5.84417 96.7533C8.00867 97.8355 10.3896 98.9177 12.7706 99.1342C17.0996 99.7835 21.4286 99.5671 25.5411 97.6191C28.1385 96.3204 30.7359 95.4546 33.5498 95.671C35.9307 95.671 37.8788 96.1039 40.0433 97.1862C43.29 98.9178 46.5368 99.5671 50.2165 99.5671C53.4632 99.5671 56.2771 98.9178 59.3074 97.4026C64.0693 95.0217 69.0476 95.0217 73.8095 97.4026C77.0563 98.9178 80.5195 99.7836 84.1992 99.5671C87.013 99.3507 89.8268 98.7013 92.4242 97.4026C94.8052 96.3204 97.1862 95.4546 99.7836 95.4546C99.7836 96.7533 99.7836 98.2684 99.7836 99.5671C66.4502 99.7836 33.3333 99.7836 0 99.7836Z",
    fill: "url(#paint1_linear_1939_91)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7836 78.5714C95.8875 78.5714 92.4242 79.8701 89.1775 81.3853C85.2814 83.1169 81.1688 83.1169 77.2727 81.3853C75.974 80.7359 74.6753 80.303 73.1602 79.6537C72.9437 79.6537 72.7273 79.4372 72.5108 79.4372C70.3463 77.2727 68.3983 75.1082 66.2338 73.1602C66.2338 73.1602 66.2338 72.9437 66.0173 72.7273C67.7489 72.9437 69.2641 72.9437 70.5628 73.1602C73.1602 73.5931 75.5411 74.6753 77.9221 75.974C80.0866 77.2727 82.2511 77.7056 84.6321 77.2727C86.1472 76.8398 87.6624 76.1905 88.9611 75.5411C92.2078 73.8095 95.8875 72.7273 99.5671 72.7273C99.7836 74.6753 99.7836 76.6234 99.7836 78.5714Z",
    fill: "url(#paint2_linear_1939_91)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8528 78.7879C61.039 79.0043 58.658 80.0866 56.0606 81.1688C51.9481 82.9004 47.8355 82.9004 43.723 81.1688C40.9091 80.0866 38.3117 78.7879 35.2814 78.5714C35.2814 78.355 35.0649 78.1385 35.0649 77.9221C35.0649 72.7273 34.8485 67.7489 35.2814 62.5541C35.7143 52.5974 39.394 44.1559 45.8875 36.5801C46.1039 36.3636 46.3204 36.1472 46.5368 35.9307V35.7143C45.671 34.632 44.8052 33.7662 43.9394 32.684C37.8788 24.6753 38.7446 13.4199 45.671 6.49351C47.8355 4.329 49.7836 2.38095 52.1645 0C54.9784 2.81385 58.0087 5.62771 60.3896 8.65801C63.8528 13.2035 64.5022 18.3983 62.7706 24.026C62.7706 24.2424 62.5541 24.4589 62.5541 24.8918C63.8528 24.6753 65.1515 24.2424 66.4502 24.026C71.8615 23.1602 76.6234 24.8918 80.5195 28.5714C82.9004 30.7359 85.065 33.1169 87.4459 35.4978C87.013 35.9307 86.5801 36.1472 86.1472 36.5801C84.4156 38.3117 82.684 40.2597 80.7359 41.9913C73.3766 48.9178 62.5541 49.3507 54.5455 43.5065C54.329 43.29 54.1126 43.0736 53.6797 42.8571C53.6797 43.0736 53.4632 43.0736 53.4632 43.29C53.4632 47.8355 53.2468 52.1645 53.4632 56.71C53.8961 64.7186 57.1429 71.645 62.5541 77.7056C62.987 78.1385 63.4199 78.355 63.8528 78.5714V78.7879Z",
    fill: "url(#paint3_linear_1939_91)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4372 72.9437C29.4372 75.1082 29.4372 77.0563 29.4372 78.7879C26.4069 79.8701 23.3766 81.3853 20.1299 82.2511C16.8831 83.1169 13.6364 82.9004 10.6061 81.3853C7.35931 79.8701 3.8961 78.5714 0 78.7879C0 76.6234 0 74.6753 0 72.7273C1.94805 72.5108 3.89611 72.7273 5.84417 73.3766C7.57577 74.026 9.30736 74.6753 10.8225 75.5411C14.7186 77.7056 18.3983 77.7056 22.2944 75.5411C24.2424 74.4589 26.1905 73.8095 28.1385 73.1602C28.5714 72.9437 29.0043 72.9437 29.4372 72.9437Z",
    fill: "url(#paint4_linear_1939_91)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1939_91",
    x1: 0.00282997,
    y1: 49.8845,
    x2: 100.011,
    y2: 49.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1939_91",
    x1: 0.00282997,
    y1: 49.8845,
    x2: 100.011,
    y2: 49.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1939_91",
    x1: 0.00282997,
    y1: 49.8845,
    x2: 100.011,
    y2: 49.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1939_91",
    x1: 0.00282997,
    y1: 49.8845,
    x2: 100.011,
    y2: 49.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1939_91",
    x1: 0.00282997,
    y1: 49.8845,
    x2: 100.011,
    y2: 49.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeces);
export default __webpack_public_path__ + "static/media/peces.d23f19d8d0656d15682d9debaf7ccea9.svg";
export { ForwardRef as ReactComponent };